import { lazy } from 'react';

/**
 * The example addon's web pages. The web app picks this file up from addons/<name>/web/index.jsx
 * (web/src/modules.js) at build time; it has the same shape as a built-in web module. Entries show
 * only while the API runs the addon (switched on under Admin → Addons, then a restart).
 *
 * Pages import the shared UI from web/src (components/ui.jsx, api.js) by relative path, and load
 * lazily so the addon is its own chunk.
 */
const page = (load, name) => () => load().then((m) => ({ Component: m[name] }));
const adminPage = () => import('./AdminHello.jsx');
const clientPage = () => import('./ClientHello.jsx');

export default {
  name: 'example-hello',
  // Admin: /admin/hello, in the System section, for staff who manage addons.
  adminRoutes: [{ path: 'hello', lazy: page(adminPage, 'AdminHello') }],
  adminNav: [
    { section: 'system', to: '/admin/hello', label: 'Hello addon', permission: 'admin.addons.manage', order: 85 },
  ],
  // Client area: /hello, for signed-in clients, plus a dashboard widget.
  clientRoutes: [{ path: 'hello', lazy: page(clientPage, 'ClientHello') }],
  clientNav: [{ key: 'hello', to: '/hello', label: 'Hello', order: 99, auth: true }],
  clientWidgets: [
    { key: 'hello', order: 99, Component: lazy(() => clientPage().then((m) => ({ default: m.HelloWidget }))) },
  ],
};
